export default __webpack_public_path__ + "81dc9b21d2ced318e9aed9cf5417e03d.ttf";